import { FC, KeyboardEventHandler, memo, useCallback, useEffect, useRef } from "react";

import { useMultiStyleConfig, HStack, chakra, Box } from "@chakra-ui/react";

import FlagIcon from "./FlagIcon";
import type { TPhoneCodeOptionProps } from "./types";

const PhoneCodeOption: FC<TPhoneCodeOptionProps> = ({ index, style, data }) => {
  const styles = useMultiStyleConfig("PhoneInput", {});

  const option = data.options[index];
  const phoneCodeOptionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (index === 0) {
      phoneCodeOptionRef.current?.focus();
    }
  });
  const handleSelect = useCallback(() => {
    data.onSelect(option);
  }, [data, option]);

  const handleEnterKeyPress: KeyboardEventHandler = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    data.onSelect(option);
  };

  return (
    <Box
      sx={styles.codeSelectMenuItem}
      style={style}
      onClick={handleSelect}
      ref={phoneCodeOptionRef}
      tabIndex={0}
      onKeyDown={handleEnterKeyPress}
    >
      <HStack spacing="0.5rem" sx={styles.codeSelectItem} tabIndex={-1}>
        <FlagIcon option={option} />
        <span>{option.label}</span>
        <chakra.span sx={styles.codeText}>{option.code}</chakra.span>
      </HStack>
    </Box>
  );
};
export default memo(PhoneCodeOption);
